// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2XjQ6","icon":"SortAdornment_icon__FmCCP","up":"SortAdornment_up__1cx1o","down":"SortAdornment_down__1ap7c","active":"SortAdornment_active__2UX0r"};